import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResearch = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 34 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#prefix__clip0_2_1097)",
		stroke: "#3C527D",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M21.25 1.617v8.5h8.5" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.75 17.2v-7.083l-8.5-8.5h-17v31.167h16.292M9.917 25.7h3.542M9.917 18.617h5.667M9.917 11.534h5.667M31.167 31.367l-4.286-4.286",
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.375 28.534a4.958 4.958 0 100-9.917 4.958 4.958 0 000 9.917z",
				strokeLinecap: "square"
			})
		]
	})
});
export default SvgResearch;
